var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelMail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M4 7.138C4 6.508 4.515 6 5.15 6h13.7c.636 0 1.15.51 1.15 1.138v1.27l-7.637 5.166c-.317.218-.317.218-.634 0L4 8.346zm0 2.385v6.684l4.877-3.37zm0 7.94a1.144 1.144 0 0 0 1.15 1.108h13.7c.635 0 1.15-.508 1.15-1.137v-.032a2004 2004 0 0 1-5.735-3.917l-1.268.963c-.317.22-1.585.22-1.902 0l-1.283-.964zm16-1.27V9.538l-4.808 3.3z",
  clipRule: "evenodd"
})));
export default SvgGemChannelMail;